import React, { useState } from 'react';
import {
  Drawer,
  Box,
  Typography,
  TextField,
  Grid,
  Button,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import { TP_COLORS } from '../../../../constants';
import {
  adminCreateSubTopic,
  IAdminCreateSubTopic,
} from '../../../../store/SubTopicSlice';
import { getSubjectColor } from '../../../../helper';
import DetailViewCard from '../../../../components/Card/DetailViewCard';

export interface IAddNewSubTopicDrawer {
  open: boolean;
  onClose: () => void;
  data: {
    subjectCode: string;
    subject: string;
    curriculum: string;
    grade: string;
    topic: string;
    topicId: string;
  };
}

const AddNewSubTopicDrawer: React.FC<IAddNewSubTopicDrawer> = ({
  open,
  onClose,
  data,
}) => {
  const dispatch = useDispatch();

  // State
  const [subTopic, setSubTopic] = useState('');
  const [sortingOrder, setSortingOrder] = useState('');

  const handleClose = () => {
    setSubTopic('');
    onClose();
  };

  const handleSubmit = () => {
    const sortingOrderNumber = Number(sortingOrder || '0');

    const API_DATA: IAdminCreateSubTopic = {
      subTopic,
      topicId: data.topicId,
    };

    if (sortingOrderNumber) {
      API_DATA.sortingOrder = sortingOrderNumber;
    }

    dispatch(adminCreateSubTopic(API_DATA));

    handleClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      PaperProps={{ style: { minWidth: '300px', maxWidth: '350px' } }}
    >
      <Box role="presentation" style={{ padding: '30px 15px' }}>
        <Typography variant="h6" fontWeight={600} sx={{ mb: '15px' }}>
          Add Sub Topic
        </Typography>
        <div>
          <DetailViewCard
            title={data.subject}
            containerProps={{
              sx: {
                color: TP_COLORS.white,
                background: getSubjectColor(data.subject),
              },
            }}
          />
          <DetailViewCard
            title={data.subjectCode}
            titleProps={{ variant: 'subtitle2' }}
          />
          <DetailViewCard
            title={data.curriculum}
            titleProps={{ variant: 'subtitle2' }}
          />
          <DetailViewCard
            title={data.grade}
            titleProps={{ variant: 'subtitle2' }}
          />
          <DetailViewCard
            title={data.topic}
            titleProps={{ variant: 'subtitle2' }}
          />
          <div style={{ marginBottom: '10px' }}>
            <Typography variant="subtitle1" fontWeight={500}>
              Sorting Order
            </Typography>
            <TextField
              type="number"
              size="small"
              fullWidth
              value={sortingOrder}
              inputProps={{ min: 0 }}
              placeholder="Enter here..."
              onChange={(event) => {
                const _val = Math.abs(Number(event.currentTarget.value));
                setSortingOrder(_val.toString());
              }}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <Typography variant="subtitle1" fontWeight={500}>
              Sub Topic
            </Typography>
            <TextField
              multiline
              fullWidth
              value={subTopic}
              rows={3}
              placeholder="Enter here..."
              onChange={(event) => setSubTopic(event.currentTarget.value)}
            />
          </div>
          <div>
            <Grid container alignItems="center" spacing={2} sx={{ mt: '15px' }}>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={subTopic.trim().length < 1}
                >
                  Create
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </Box>
    </Drawer>
  );
};

export default AddNewSubTopicDrawer;
